import { type ApiGatewayWorkbenchApiKey } from "@vega-api/generated/types/apiGatewayWorkbenchApiKey";

export enum KeyStatus {
  Active = "ACTIVE",
  Expired = "EXPIRED",
  Deactivated = "DEACTIVATED",
}

/**
 * Single source of truth for a reporting API key's effective status.
 *
 * The backend `active` column is a stored boolean that only flips on explicit
 * deactivation — it is NOT updated when the key passes its `expiresAt`, so an
 * expired key still reads `active = true` while the gateway rejects it. Any
 * consumer reading `active` directly would show a dead key as healthy; always
 * derive status through this function instead.
 */
export const deriveKeyStatus = (
  key: Pick<ApiGatewayWorkbenchApiKey, "active" | "expiresAt">,
  now: Date = new Date(),
): KeyStatus => {
  if (!key.active) {
    return KeyStatus.Deactivated;
  }

  return new Date(key.expiresAt).getTime() > now.getTime()
    ? KeyStatus.Active
    : KeyStatus.Expired;
};
